import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../services/api";

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const response = await api.post("token/", { email, password });
      localStorage.setItem("access", response.data.access);
      localStorage.setItem("refresh", response.data.refresh);
      setLoading(false);
      navigate("/dashboard");
    } catch (err) {
      setLoading(false);
      if (err.response?.status === 401) setError("Invalid email or password.");
      else if (err.response?.data?.detail) setError(err.response.data.detail);
      else setError("Unable to sign in. Please try again.");
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        body {
          font-family: 'Inter', sans-serif; min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 1rem;
          background: linear-gradient(135deg, rgba(0,137,123,0.82) 0%, rgba(0,60,50,0.88) 100%),
            url('https://images.unsplash.com/photo-1586773860418-d37222d8fce3?w=1600&auto=format&fit=crop&q=80') center/cover no-repeat fixed;
        }
        .page-wrap { display: flex; width: 100%; max-width: 900px; min-height: 580px; border-radius: 20px; overflow: hidden; box-shadow: 0 24px 80px rgba(0,0,0,0.45); }
        .left { width: 340px; flex-shrink: 0; padding: 3rem 2.5rem; background: rgba(255,255,255,0.06); backdrop-filter: blur(12px); border-right: 1px solid rgba(255,255,255,0.1); display: flex; flex-direction: column; justify-content: space-between; }
        .logo-row { display: flex; align-items: center; gap: 10px; margin-bottom: 2rem; }
        .logo-name { font-size: 16px; font-weight: 700; color: #fff; line-height: 1.1; }
        .logo-sub { font-size: 10px; color: rgba(255,255,255,0.5); font-weight: 400; }
        .left-title { font-size: 26px; font-weight: 700; color: #fff; line-height: 1.25; margin-bottom: 12px; }
        .left-desc { font-size: 13px; color: rgba(255,255,255,0.6); line-height: 1.7; margin-bottom: 2rem; }
        .feat-list { display: flex; flex-direction: column; gap: 12px; }
        .feat { display: flex; align-items: flex-start; gap: 10px; }
        .feat-ico { width: 34px; height: 34px; border-radius: 8px; background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.15); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
        .feat-ico svg { width: 16px; height: 16px; stroke: rgba(255,255,255,0.85); fill: none; stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round; }
        .feat-title { font-size: 13px; font-weight: 600; color: #fff; margin-bottom: 2px; }
        .feat-sub { font-size: 11.5px; color: rgba(255,255,255,0.45); }
        .trust-row { display: flex; align-items: center; gap: 7px; font-size: 11px; color: rgba(255,255,255,0.35); }
        .trust-dot { width: 5px; height: 5px; border-radius: 50%; background: #4ade80; flex-shrink: 0; }
        .compliance-badges { display: flex; gap: 6px; margin-top: 10px; flex-wrap: wrap; }
        .badge { font-size: 10px; font-weight: 600; padding: 3px 8px; border-radius: 20px; background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2); color: rgba(255,255,255,0.7); }
        .right { flex: 1; background: #fff; padding: 3rem 2.5rem; display: flex; flex-direction: column; justify-content: center; }
        .form-head { margin-bottom: 1.75rem; }
        .form-head h2 { font-size: 22px; font-weight: 700; color: #0f172a; margin-bottom: 4px; }
        .form-head p { font-size: 13px; color: #64748b; }
        .field { margin-bottom: 1rem; }
        .field label { display: block; font-size: 12px; font-weight: 500; color: #475569; margin-bottom: 6px; }
        .input-wrap { position: relative; display: flex; align-items: center; }
        .input-wrap .ico { position: absolute; left: 11px; width: 15px; height: 15px; stroke: #94a3b8; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; pointer-events: none; }
        .input-wrap input { width: 100%; height: 42px; padding: 0 36px; font-size: 13px; border: 1px solid #e2e8f0; border-radius: 8px; background: #f8fafc; color: #0f172a; outline: none; transition: border-color 0.15s, box-shadow 0.15s, background 0.15s; }
        .input-wrap input:focus { border-color: #00897B; box-shadow: 0 0 0 3px rgba(0,137,123,0.1); background: #fff; }
        .toggle-pw { position: absolute; right: 10px; background: none; border: none; cursor: pointer; padding: 4px; display: flex; align-items: center; }
        .toggle-pw svg { width: 15px; height: 15px; stroke: #94a3b8; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
        .row-opts { display: flex; align-items: center; justify-content: space-between; margin-bottom: 1.25rem; }
        .check-wrap { display: flex; align-items: center; gap: 6px; font-size: 12px; color: #64748b; cursor: pointer; }
        .check-wrap input { accent-color: #00897B; width: 13px; height: 13px; }
        .forgot { font-size: 12px; color: #00897B; text-decoration: none; font-weight: 500; }
        .forgot:hover { text-decoration: underline; }
        .btn-primary { width: 100%; height: 42px; background: #00897B; color: #fff; border: none; border-radius: 8px; font-size: 14px; font-weight: 600; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; transition: background 0.15s; margin-bottom: 10px; }
        .btn-primary:hover { background: #00695C; }
        .btn-primary:disabled { opacity: 0.7; cursor: not-allowed; }
        .btn-outline { width: 100%; height: 42px; background: #f8fafc; color: #334155; border: 1px solid #e2e8f0; border-radius: 8px; font-size: 14px; font-weight: 500; cursor: pointer; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: background 0.15s; }
        .btn-outline:hover { background: #f1f5f9; }
        .divider { display: flex; align-items: center; gap: 10px; margin: 10px 0; color: #cbd5e1; font-size: 12px; }
        .divider::before, .divider::after { content: ''; flex: 1; height: 1px; background: #e2e8f0; }
        .alert-err { background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; padding: 10px 12px; font-size: 12px; color: #dc2626; margin-bottom: 1rem; display: flex; align-items: center; gap: 8px; }
        .footer-note { font-size: 11px; color: #94a3b8; text-align: center; margin-top: 1.25rem; line-height: 1.6; }
        .footer-note a { color: #00897B; text-decoration: none; font-weight: 500; }
        .spinner { width: 14px; height: 14px; border: 2px solid rgba(255,255,255,0.3); border-top-color: #fff; border-radius: 50%; animation: spin 0.6s linear infinite; }
        @keyframes spin { to { transform: rotate(360deg); } }
        @media (max-width: 700px) { .left { display: none; } .right { padding: 2rem 1.5rem; } }
      `}</style>

      <div className="page-wrap">
        <div className="left">
          <div>
            <div className="logo-row">
              <img src="/micronlabs.png" alt="MicronLabs Logo" style={{ width:"40px", height:"40px", borderRadius:"10px", objectFit:"contain", flexShrink:0 }}/>
              <div>
                <div className="logo-name">MicronLabs</div>
                <div className="logo-sub">Laboratory Information System</div>
              </div>
            </div>
            <div className="left-title">Secure access to your lab portal</div>
            <p className="left-desc">Sign in to manage test orders, view results, access patient records and collaborate with your care team — all in one HIPAA-compliant platform.</p>
            <div className="feat-list">
              <div className="feat">
                <div className="feat-ico"><svg viewBox="0 0 24 24"><path d="M9 3h6M9 3v8l-4 9h14l-4-9V3"/></svg></div>
                <div><div className="feat-title">E-Requisition system</div><div className="feat-sub">Submit digital test orders instantly</div></div>
              </div>
              <div className="feat">
                <div className="feat-ico"><svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8"/></svg></div>
                <div><div className="feat-title">Digital PDF results</div><div className="feat-sub">Download and share reports instantly</div></div>
              </div>
              <div className="feat">
                <div className="feat-ico"><svg viewBox="0 0 24 24"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg></div>
                <div><div className="feat-title">Real-time specimen tracking</div><div className="feat-sub">Track from collection to result</div></div>
              </div>
            </div>
          </div>
          <div>
            <div className="trust-row"><span className="trust-dot"></span>Secure · Encrypted · US-based infrastructure</div>
            <div className="compliance-badges">
              <span className="badge">HIPAA</span><span className="badge">CLIA</span><span className="badge">SOC 2</span><span className="badge">HL7</span>
            </div>
          </div>
        </div>

        <div className="right">
          <div className="form-head">
            <h2>Welcome back</h2>
            <p>Sign in to your MicronLabs portal</p>
          </div>
          {error && (
            <div className="alert-err">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              {error}
            </div>
          )}
          <form onSubmit={handleLogin}>
            <div className="field">
              <label htmlFor="email">Email address</label>
              <div className="input-wrap">
                <svg className="ico" viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                <input type="email" id="email" placeholder="you@organization.com" value={email} onChange={e => setEmail(e.target.value)} required disabled={loading} autoComplete="email"/>
              </div>
            </div>
            <div className="field">
              <label htmlFor="password">Password</label>
              <div className="input-wrap">
                <svg className="ico" viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
                <input type={showPassword ? "text" : "password"} id="password" placeholder="Enter your password" value={password} onChange={e => setPassword(e.target.value)} required disabled={loading} autoComplete="current-password"/>
                <button type="button" className="toggle-pw" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <svg viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg> : <svg viewBox="0 0 24 24"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>}
                </button>
              </div>
            </div>
            <div className="row-opts">
              <label className="check-wrap"><input type="checkbox" id="remember"/> Remember me</label>
              <Link to="/forgot-password" className="forgot">Forgot password?</Link>
            </div>
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading && <span className="spinner"/>}
              {loading ? "Signing in..." : "Sign in"}
            </button>
            <div className="divider">or</div>
            <Link to="/signup" className="btn-outline">Create an account</Link>
            <p className="footer-note">
              By signing in you agree to our <Link to="/terms">Terms of Service</Link> and <Link to="/privacy">Privacy Policy</Link>.<br/>
              MicronLabs is HIPAA compliant. Your data is protected.
            </p>
          </form>
        </div>
      </div>
    </>
  );
}

export default LoginPage;